exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oh[data-v-3b245357]{overflow:hidden;height:36px}.filter-tags[data-v-3b245357]{text-align:left}.tags_active[data-v-3b245357]{color:#1890ff;border:1px solid #1890ff!important;background:#ecf5ff!important;border-radius:4px;padding-top:0!important;box-sizing:border-box}.tags_active_un[data-v-3b245357]{color:#606266;padding-top:0!important;box-sizing:border-box}.isSplit[data-v-3b245357]{position:relative;margin-right:55px!important}.isSplit[data-v-3b245357]:after{content:\"\";display:block;width:1px;height:13px;background:#ebeef5;font-size:20px;position:absolute;top:7px;right:-30px}.label[data-v-3b245357]{display:inline-block;font-size:14px;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b245357","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./UI/Tags/index.vue
// module id = 573
// module chunks = 0